

















import { useUserStore } from "@/shared/store/user";
import {
  Vue,
  Component, Prop,
} from "@/shared/vuepack";
import EmployerMassTransitSettingsForm from "@/admin/components/employer-management/EmployerMassTransitSettingsForm.vue";

@Component({
  components: {
    EmployerMassTransitSettingsForm,
  }
})
export default class EmployerMassTransitSettings extends Vue {
  userStore = useUserStore();

  @Prop({ required: true })
  employerId: number;
}
